import { AppState, FeedPageNairobiAppState } from '../../../initialStateRegistration';
import { SECTION_NAMES } from '../../../../templates/templates.const';

export const getFeedPage = (state: AppState) => (state as FeedPageNairobiAppState).template;

export const getTopSection = (state: AppState) => getFeedPage(state)[SECTION_NAMES.TOP_SECTION];

export const getFeedSection = (state: AppState) => getFeedPage(state)[SECTION_NAMES.FEED_SECTION];

export const getTopSectionTitle = (state: AppState) => getTopSection(state).sectionTitle;

export const getTopSectionSubtitle = (state: AppState) => getTopSection(state).sectionSubtitle;

export const getTopSectionImage = (state: AppState) => getTopSection(state).image;

export const getFeedSectionArticles = (state: AppState) => getFeedSection(state).articles;

export const getPagination = (state: AppState) => getFeedPage(state).pagination;

export const getMetadataDescription = (state: AppState) => getFeedPage(state).metadataDescription;

export const getMetadataTitle = (state: AppState) => getFeedPage(state).metadataTitle;

export const getMetadataImage = (state: AppState) => getFeedPage(state).metadataImage;

export const getHreflangData = (state: AppState) => getFeedPage(state).hreflangData;
